module.exports = __webpack_public_path__ + "img/progress_096.76278a10.png";